import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Supplier } from '../models/supplier.entity'

export type SupplierNotificationCode =
  | GenericNotificationCode
  | 'SUPPLIER_DELETED'
  | 'SUPPLIER_SAVED'

export type SupplierModalCode = 'SUPPLIER_DELETION'

/**
 * Parse supplier code to a notification
 * @param code - the supplier notification code
 * @returns the notification options
 */
export function parseSupplierNotification(
  code?: SupplierNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'SUPPLIER_DELETED':
      return {
        message: 'Supplier deleted successfully',
        color: 'success',
      }
    case 'SUPPLIER_SAVED':
      return {
        message: 'Supplier saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse supplier code to an modal
 * @param code - the supplier modal code
 * @param supplier - the supplier object
 * @returns the modal settings
 */
export function parseSupplierModal(
  code: SupplierModalCode,
  supplier?: Supplier,
): DialogOptions {
  switch (code) {
    case 'SUPPLIER_DELETION': {
      const suppName = supplier?.businessName
      return {
        title: 'Delete supplier',
        message:
          'You are about to delete the supplier <strong>%s</strong>. Proceed with deletion?',
        messageParams: suppName ? [suppName] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
